export function civilDate(value: string): string {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) throw new Error("invalid_date");
  const date = new Date(`${value}T12:00:00Z`);
  if (
    !Number.isFinite(date.getTime()) ||
    date.toISOString().slice(0, 10) !== value
  )
    throw new Error("invalid_date");
  return value;
}
export function monthKey(value: string): string {
  if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(value)) throw new Error("invalid_month");
  return value;
}
export function anchoredDate(month: string, anchor: number): string {
  monthKey(month);
  if (!Number.isInteger(anchor) || anchor < 1 || anchor > 31)
    throw new Error("invalid_anchor");
  const [year, number] = month.split("-").map(Number);
  const leap = year! % 4 === 0 && (year! % 100 !== 0 || year! % 400 === 0);
  const last = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][
    number! - 1
  ]!;
  return civilDate(
    `${month}-${String(Math.min(anchor, last)).padStart(2, "0")}`,
  );
}
export function addMonths(month: string, offset: number): string {
  monthKey(month);
  if (!Number.isInteger(offset)) throw new Error("invalid_offset");
  const [year, number] = month.split("-").map(Number);
  const index = year! * 12 + number! - 1 + offset;
  if (index < 0 || index > 9999 * 12 + 11)
    throw new Error("invalid_month_range");
  return `${String(Math.floor(index / 12)).padStart(4, "0")}-${String((index % 12) + 1).padStart(2, "0")}`;
}
export function installmentSchedule(
  total: bigint,
  count: number,
  current: number | null,
  firstMonth: string,
) {
  if (current === null)
    return {
      remainingCount: null,
      months: null,
      issue: "installment_position_missing",
    };
  if (!Number.isInteger(current) || current < 1 || current > count)
    throw new Error("invalid_position");
  return {
    remainingCount: count - current,
    months: Array.from({ length: count - current }, (_, i) => ({
      month: addMonths(firstMonth, i + 1),
      position: current + i + 1,
    })),
    total,
    issue: null,
  };
}
